/**
 * TanStack Query hooks for `customizable-table-columns-per-view`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customizableTableColumnsPerViewQueryKeys,
	type CreateCustomizableTableColumnsPerViewBody,
	type ListCustomizableTableColumnsPerViewResponse,
	type CustomizableTableColumnsPerViewRow,
} from "./api";

export function useCustomizableTableColumnsPerViewList(): UseQueryResult<ListCustomizableTableColumnsPerViewResponse, Error> {
	return useQuery({
		queryKey: customizableTableColumnsPerViewQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomizableTableColumnsPerViewCreate(): UseMutationResult<CustomizableTableColumnsPerViewRow, Error, CreateCustomizableTableColumnsPerViewBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customizableTableColumnsPerViewQueryKeys.all });
		},
	});
}

export function useCustomizableTableColumnsPerViewDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customizableTableColumnsPerViewQueryKeys.all });
		},
	});
}
